import styled from 'styled-components';

export const TeamPageWrapper = styled.div`
	padding: 20px 0;
`;
